var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import SupplierService from '../../../api/SupplierService';
var LeftTree = (function (_super) {
    __extends(LeftTree, _super);
    function LeftTree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultProps = {
            label: 'category_name',
            id: "category_id"
        };
        return _this;
    }
    LeftTree.prototype.created = function () {
        this.service = SupplierService.getInstance();
    };
    LeftTree.prototype.mounted = function () {
        var height = document.documentElement.clientHeight - 226;
        this.$refs.tree.$el.style.maxHeight = height + 'px';
    };
    LeftTree.prototype.filterNode = function (value, data) {
        if (!value)
            return true;
        return data.category_name.indexOf(value) !== -1;
    };
    LeftTree.prototype.nodeClick = function (data, node, target) {
        this.$emit('node-click', data);
    };
    LeftTree.prototype.nodeCollapse = function (data, node, target) {
        this.$emit('node-collapse');
    };
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], LeftTree.prototype, "data", void 0);
    LeftTree = __decorate([
        Component({
            methods: {
                renderContent: function (h, _a) {
                    var node = _a.node, data = _a.data, store = _a.store;
                    return h('span', {
                        class: 'supplier-custom-category',
                        domProps: {
                            title: "" + data.category_name + (data.category_code ? "\uFF08" + data.category_code + "\uFF09" : ''),
                            innerHTML: "" + data.category_name + (data.category_code ? "\uFF08" + data.category_code + "\uFF09" : '')
                        }
                    });
                }
            }
        })
    ], LeftTree);
    return LeftTree;
}(Vue));
export default LeftTree;
